// extracted by mini-css-extract-plugin
export var card = "_kj-5";
export var cardSelected = "_kj-4";
export var image = "_kj-3";
export var modal = "_kj-0";
export var modalContent = "_kj-1";
export var table = "_kj-2";